import { __assign } from 'tslib';
import React__default from 'react';
import { styled, Box, Button } from '@mui/material';
import clsx from 'clsx';

var KInputFileToBase64 = function (_a) {
    var _b = _a.labelButton, labelButton = _b === void 0 ? "" : _b, onFileUploaded = _a.onFileUploaded, className = _a.className, sx = _a.sx;
    var base64Prefix = "base64,";
    var handleFileChange = function (e) {
        if (e.target.files && e.target.files.length === 1) {
            var file_1 = e.target.files[0];
            var reader_1 = new FileReader();
            reader_1.readAsDataURL(file_1);
            reader_1.onload = function () {
                if (onFileUploaded && reader_1.result) {
                    onFileUploaded(file_1, reader_1.result ? reader_1.result.split(base64Prefix).pop() : "");
                }
            };
            reader_1.onerror = function (error) {
                console.log("Error while uploadling file ".concat(file_1 === null || file_1 === void 0 ? void 0 : file_1.name, ": "), error);
            };
        }
        e.currentTarget.value = "";
    };
    return (React__default.createElement(Box, { "data-testid": "kInputFileToBase64", sx: __assign(__assign({}, sx), { marginBottom: function (theme) { return theme.spacing(3); } }), className: clsx("KInputFileToBase64", className) },
        React__default.createElement(Button, { size: "large", sx: { fontSize: "larger" }, component: "label", variant: "contained", color: "primary" },
            labelButton,
            React__default.createElement(Box, { "data-testid": "kInputFileToBase64Input" },
                React__default.createElement(VisuallyHiddenInput, { onChange: handleFileChange, type: "file", accept: "image/*" })))));
};
var VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 4,
    whiteSpace: "nowrap",
    width: 1
});

export { KInputFileToBase64, KInputFileToBase64 as default };
//# sourceMappingURL=index.js.map
